import React, { Component } from "react"
import Modal from "react-modal"
import PropTypes from "prop-types"
import closeIcon from "../Icons/svgs/close-icon.svg"

class ModalComp extends Component {
  constructor() {
    super()
    this.state = {}
  }

  render() {
    const {
      modalContents,
      modalIsOpen,
      closeModal,
      hideCloseIcon,
      shouldCloseOnOverlayClick,
    } = this.props

    const ModalContents = modalContents
    return (
      <div className="max-width-100pc">
        <Modal
          isOpen={modalIsOpen}
          className="modal-styling"
          onRequestClose={closeModal}
          shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <div className="modal-contents display-flex">
            {!hideCloseIcon && (
              <div
                className="modal-close-button-styling"
                tabIndex={0}
                role="button"
                onKeyUp={closeModal}
                onClick={closeModal}
              >
                <img src={closeIcon} alt="close-button-svg" />
              </div>
            )}
            <br />
            <br />
            <div className="max-width-100pc">
              <ModalContents />
            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

ModalComp.propTypes = {
  modalContents: PropTypes.func,
  modalIsOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  hideCloseIcon: PropTypes.bool,
  shouldCloseOnOverlayClick: PropTypes.bool,
}

ModalComp.defaultProps = {
  modalContents: () => null,
  modalIsOpen: false,
  closeModal: () => null,
  hideCloseIcon: false,
  shouldCloseOnOverlayClick: true,
}

export default ModalComp
